import moment from 'moment';
import React, { useEffect, useRef } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { getValueFromResource } from '../../common/timeLiveFunction';
import { useAppDispatch } from '../../app/hooks';
import { useTranslation } from 'react-i18next';

export const WorkingHours = ({ showTimezonePopover, splithours, onClose, setShowTimezonePopover, onMouseEnter, onMouseLeave, position }: any) => {
    const popoverRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target as Node) && !(event.target as HTMLElement).closest('.bi-hourglass-split')) {
                onClose();
            }
        };

        if (showTimezonePopover) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showTimezonePopover, onClose]);

    if (!showTimezonePopover) return null;

    return (
        <div
            ref={popoverRef}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className="popover bs-popover-top show"
            style={{
                position: 'fixed',
                top: `${position.top}px`,
                left: `${position.left - 480}px`,
                width: '550px',
                maxWidth: '500px',
                maxHeight: '300px',
                zIndex: 1060,
                backgroundColor: 'white',
                border: '1px solid #eee',
                borderRadius: '0.7rem',
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                overflow: 'hidden'
            }}>
            <div className="popover-arrow" style={{
                position: 'absolute',
                top: '-6px',
                right: '15px',
                width: '12px',
                height: '6px',
                marginLeft: '-6px'
            }}>
                <div style={{
                    position: 'absolute',
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    transform: 'rotate(45deg)',
                    borderTop: '1px solid rgba(0,0,0,.2)',
                    borderLeft: '1px solid rgba(0,0,0,.2)',
                    top: '3px',
                    left: '0'
                }}></div>
            </div>
            <div className="popover-header" style={{
                padding: '1rem 1rem',
                margin: 0,
                fontSize: '0.875rem',
                backgroundColor: '#fff',
                borderBottom: '1px solid #ebebeb',
                borderTopLeftRadius: 'calc(0.3rem - 1px)',
                borderTopRightRadius: 'calc(0.3rem - 1px)'
            }}>
                {getValueFromResource('Time Allocation Split', dispatch, t)}
            </div>
            <div className="popover-body" style={{
                padding: '0.5rem 0.75rem',
                width: '100%',
                overflowX: 'auto',
                maxHeight: '250px',
                overflowY: 'auto'
            }}>
                <div className='table-responsive' style={{ width: '100%', maxHeight: '220px' }}>
                    <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" style={{ width: '100%' }}>
                        <thead>
                            <tr className="thHeading align-middle">
                                <th style={{ width: '20%' }}>
                                    Date
                                </th>
                                <th style={{ width: '20%' }}>
                                    Start Time
                                </th>
                                <th style={{ width: '20%' }}>
                                    End Time
                                </th>
                                <th style={{ width: '20%', textAlign: 'center', verticalAlign: 'middle' }}>
                                    Total Hours
                                </th>
                                <th style={{ width: '20%', textAlign: 'center', verticalAlign: 'middle' }}>
                                    Status
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {splithours?.map((item: any, index: number) => (
                                <tr key={index} className='thHeading align-middle'>
                                    <td style={{ width: '20%' }}>{moment(item?.startDateTime).format('YYYY-MM-DD')}</td>
                                    <td style={{ width: '20%' }}>
                                        <span className="d-block">
                                            {moment(item?.startDateTime).format("hh:mm A")}
                                        </span>
                                    </td>
                                    <td style={{ width: '20%' }}>
                                        <span className="d-block">
                                            {moment(item?.endDateTime).format("hh:mm A")}
                                        </span>
                                    </td>
                                    <td style={{ width: '20%', textAlign: 'center', verticalAlign: 'middle' }}>
                                        <span className="d-block">
                                            {item?.duration}
                                        </span>
                                    </td>
                                    <td style={{ width: '20%', textAlign: 'center', verticalAlign: 'middle' }}>
                                        <span className="d-block">
                                            {item?.Locked ? <i className="bi bi-lock fs-5 iconColor align-middle" data-tooltip-id="tooltip-Table" data-tooltip-content={getValueFromResource('Submission complete', dispatch, t)}></i> : <i className="bi bi-unlock fs-5 iconColor allign" data-tooltip-id="tooltip-Table" data-tooltip-content={getValueFromResource('Submission required', dispatch, t)}></i>}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ReactTooltip
                id="tooltip-Table"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 10000
                }}
                place="top"
            />
        </div>
    )
};